import VisualizarContaCaixinha from './VisualizarContaCaixinha';

export default VisualizarContaCaixinha;
